// extracted by mini-css-extract-plugin
export default {"container":"privacyPolicy_container__Jkl6i","header":"privacyPolicy_header__5u+Lt","updatedDate":"privacyPolicy_updatedDate__AF28x","list":"privacyPolicy_list__Klnc5"};